import { NavLink } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

function DocsSidebar({ sections, activeSectionId, basePath }) {
  return (
    <Nav className="flex-column pt-3">
      {sections.map(section => (
        <Nav.Link
          as={NavLink}
          key={section.id}
          to={`${basePath}/${section.id}`}
          className="sidebar-link"
        >
          {section.title}
        </Nav.Link>
      ))}
    </Nav>
  );
}

export default DocsSidebar;
